"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDetails = exports.filterOption = void 0;
const react_1 = __importDefault(require("react"));
const react_select_1 = require("react-select");
const classnames_1 = __importDefault(require("classnames"));
const pluralize_1 = __importDefault(require("pluralize"));
const prop_types_1 = __importDefault(require("prop-types"));
const typography_1 = __importDefault(require("../../typography/typography"));
const user_avatar_1 = __importStar(require("../../user-avatar/user-avatar"));
require("../../../styles/components/react-select/react-select.less");
require("../../../styles/components/react-select/user-option.less");
const UserDetails = (option) => {
    const { fullName, label, value, avatarId, accountRole, hasFullDetails, isPool, isContact, imgUrl, usersCount, isKeyContact, className, amountOfUse, __isNew__: isNew, email } = option;
    const classes = `option-text ${className || ''}`;
    const amountOfUseText = amountOfUse > 0 ? `Configured in ${amountOfUse} ${(0, pluralize_1.default)('SuccessPlay', amountOfUse)}` : 'Not used yet';
    const avatarProps = { fullName: fullName || label, isContact, email: email || value, avatarId, imgUrl, size: 32 };
    return (react_1.default.createElement("div", { className: "user-option-wrapper option-wrapper" },
        isPool ? react_1.default.createElement("i", { className: "material-icons pool-icon" }, "group") : '',
        hasFullDetails && !isPool ? react_1.default.createElement(user_avatar_1.AvatarComp, { ...avatarProps }) : '',
        !hasFullDetails && !isPool ? react_1.default.createElement(user_avatar_1.default, { ...avatarProps }) : '',
        react_1.default.createElement("div", { className: "option-name-wrapper" },
            react_1.default.createElement(typography_1.default, { component: "div", variant: "body2", className: classes },
                react_1.default.createElement(react_1.default.Fragment, null,
                    fullName || label,
                    isKeyContact ? react_1.default.createElement("i", { className: "icon-key_contacts_crown" }) : '')),
            !isNew ? (react_1.default.createElement(typography_1.default, { variant: "caption", component: "div", className: `${classes} email-text` }, email || value)) : '',
            isPool && (react_1.default.createElement("div", { className: "pool-content" },
                react_1.default.createElement("div", { className: "users-count" },
                    react_1.default.createElement("span", { className: "count-holder" },
                        react_1.default.createElement("span", { className: "number" }, usersCount)),
                    "Team Members"),
                react_1.default.createElement("div", { className: "amount-of-use" },
                    react_1.default.createElement("span", { className: "border" }),
                    amountOfUseText)))),
        accountRole ? react_1.default.createElement("div", { className: "role" }, accountRole) : ''));
};
exports.UserDetails = UserDetails;
const UserOption = (props) => {
    const { innerRef, isFocused, innerProps, data, isDefaultGroup, className } = props;
    const { label, isPool } = data;
    const classes = `option-text ${className}`;
    const { __isNew__: isNew } = data;
    if (!data) {
        return react_1.default.createElement("div", null);
    }
    if (data.renderDefaultComponent) {
        return react_1.default.createElement(react_select_1.components.Option, { ...props });
    }
    if (isNew) {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('option-container new-option', { 'option-focused': isFocused }), ref: innerRef, ...innerProps }, data.label));
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('option-container', { 'option-focused': isFocused }), ref: innerRef, ...innerProps },
        react_1.default.createElement("div", { className: "option-wrapper" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('option-container', { 'option-focused': isFocused, 'pool-option': !!isPool }) }, isDefaultGroup ? (react_1.default.createElement("div", { className: classes }, label)) : (react_1.default.createElement(UserDetails, { ...data }))))));
};
UserOption.defaultProps = {
    data: {},
    isFocused: false,
    isDefaultGroup: false,
    className: '',
    ref: null,
    restInnerProps: {},
};
UserOption.propTypes = {
    data: prop_types_1.default.shape({
        fullName: prop_types_1.default.string,
        value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
        label: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]),
        avatarId: prop_types_1.default.string,
    }),
    isFocused: prop_types_1.default.bool,
    isDefaultGroup: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    ref: prop_types_1.default.any,
    restInnerProps: prop_types_1.default.object,
};
const filterOption = ({ data: { fullName = '', value = '' } }, inputValue = '') => fullName.toLowerCase().startsWith(inputValue.toLowerCase()) || value.toLowerCase().startsWith(inputValue.toLowerCase());
exports.filterOption = filterOption;
exports.default = UserOption;
//# sourceMappingURL=user-option.js.map